// extracted by mini-css-extract-plugin
module.exports = {"cls1":"styles-ListHeader-module--cls1--Z1WBd","cls2":"styles-ListHeader-module--cls2--VhBJi styles-ListHeader-module--cls1--Z1WBd"};